/**
 * HTTP types and enums - replacement for @amzn/wish-web-core-common HTTP types
 */

export enum HttpMethod {
    GET = 'GET',
    POST = 'POST',
    PUT = 'PUT',
    DELETE = 'DELETE',
    PATCH = 'PATCH'
}

export enum AuthenticationMethod {
    None = 'none',
    MidwayToken = 'midway-token',
    ApiKey = 'api-key'
}

export interface RequestOptions {
    httpConfig?: {
        headers?: { [key: string]: string };
        timeout?: number;
    };
    authMethod?: AuthenticationMethod;
}

export interface ApiServiceConfig {
    baseUrl: string;
    authMethod?: AuthenticationMethod;
    apiKey?: string;
    timeout?: number;
}

export interface HttpResponse<T = any> {
    data: T;
    status: number;
    statusText: string;
    headers: any;
}
